/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * A self-rollback: the daemon reverted an update that did not stabilize.
 */
export type AgentStateRollback = {
  /**
   * When the rollback happened.
   */
  at: Date;
  /**
   * Version that failed to stabilize.
   */
  from?: string | undefined;
  /**
   * Version the daemon reverted to.
   */
  to?: string | undefined;
};

/** @internal */
export type AgentStateRollback$Outbound = {
  at: string;
  from?: string | undefined;
  to?: string | undefined;
};

/** @internal */
export const AgentStateRollback$outboundSchema: z.ZodMiniType<
  AgentStateRollback$Outbound,
  AgentStateRollback
> = z.object({
  at: z.pipe(z.date(), z.transform(v => v.toISOString())),
  from: z.optional(z.string()),
  to: z.optional(z.string()),
});

export function agentStateRollbackToJSON(
  agentStateRollback: AgentStateRollback,
): string {
  return JSON.stringify(
    AgentStateRollback$outboundSchema.parse(agentStateRollback),
  );
}
